/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  document.body.classList.remove('home-animation');

  setTimeout(() => {
    document.body.classList.remove('home-animation-loaded');
  }, 700);
}());